import StackableSnackbar from './StackableSnackbar';

export default {
  functional: true,
  render(el, context) {
    let offset = 0;
    return context.parent.$store.state.alert.items.map((i) => el(StackableSnackbar, {
      props: {
        value: i,
        offset: offset++ * 50
      }
    }));
  }
};
